module.exports = __webpack_public_path__ + "img/jumeirah-marsa-arab_1.86a9aabd.jpg";